import { Wifi, X } from "lucide-react";

export default function OnlineStatusModal({
  open,
  onClose,
  online,
}: {
  open: boolean;
  onClose: () => void;
  online: boolean;
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md mx-auto">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="p-8 pb-6 flex flex-col items-center">
          <Wifi className={online ? "text-green-600 w-10 h-10 mb-4" : "text-black w-10 h-10 mb-4"} />
          <h2 className="text-2xl font-bold mb-2 text-gray-800">
            {online ? "Real-time Data" : "Offline Mode"}
          </h2>
          <p className="text-gray-600 text-center mb-6">
            {online
              ? "You are connected to real-time data."
              : (
                <>
                  You are currently viewing cached data.<br />
                  Some features may be unavailable until you reconnect.
                </>
              )
            }
          </p>
          <div className="w-full text-center">
            {online ? (
              <span className="inline-block px-4 py-2 rounded-lg bg-green-100 text-green-700 font-medium">
                Real-time data available
              </span>
            ) : (
              <span className="inline-block px-4 py-2 rounded-lg bg-gray-100 text-gray-600 font-medium">
                Last updated 2 hours ago
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}